module.exports = __webpack_public_path__ + "img/2_8_04.78ab5261.png";